// eslint-disable-next-line prefer-regex-literals
const regex = new RegExp(/^[a-z ,.'-]*$/i);

class NameValidations {
  public nameValidation (str: string) : boolean {
    return regex.test(str);
  }
}

export const nameValidations = new NameValidations();
